var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeNet1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 788,
    height: 380,
    viewBox: "0 0 788 380",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M-7.00002 234.917L-3.79734 236.078L-7.00002 235.734V236.894L5.78931 238.291L-7.00002 233.671V234.917Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99997 149.335L29.9493 167.233L-6.99997 196.434V197.938L32.1418 166.997L-6.99997 148.024V149.335Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99995 197.938L29.5839 169.017L0.673645 236.443L-6.99995 233.671V234.917L0.781092 237.732L1.31846 237.926L32.4857 165.235L-6.99995 196.434V197.938Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M190.6 305.76L189.31 232.038L199.563 240.611L198.811 241.514L190.514 234.573L191.653 299.013L200.144 245.059L201.304 245.252L191.761 305.846L190.6 305.76Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M198.08 244.866C198.317 243.426 199.671 242.438 201.111 242.653C202.551 242.889 203.54 244.243 203.325 245.682C203.088 247.122 201.734 248.11 200.294 247.895C198.854 247.681 197.865 246.305 198.08 244.866Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M197.392 242.996C198.51 243.942 200.187 243.791 201.132 242.674C202.078 241.557 201.928 239.881 200.81 238.957C199.692 238.011 198.016 238.162 197.07 239.279C196.124 240.396 196.275 242.072 197.392 243.018V242.996Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.38
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M239.608 379.267L190.342 355.846L189.848 356.92L236.878 379.267H239.608Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.38
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M189.633 379.267L188.537 357.78L187.376 357.844L188.451 379.267H189.633Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M185.312 358.081C185.248 356.62 186.366 355.373 187.827 355.309C189.289 355.244 190.536 356.362 190.6 357.823C190.664 359.284 189.547 360.53 188.085 360.595C186.624 360.659 185.377 359.542 185.312 358.081Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M191.352 354.041C190.041 353.418 188.451 353.977 187.827 355.287C187.204 356.598 187.763 358.188 189.074 358.811C190.385 359.434 191.976 358.876 192.599 357.565C193.222 356.254 192.664 354.664 191.352 354.041Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.00001 148.024V149.335L30.7876 167.642L31.3678 167.942L57.5484 92.1363L56.4522 91.7495L30.7015 166.309L-7.00001 148.024Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.00003 120.886L55.8072 91.191L55.2913 90.1166L-7.00003 119.575V120.886Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3027 88.3116C55.6139 87.6885 57.2044 88.2471 57.8277 89.5793C58.4511 90.89 57.8923 92.4801 56.5596 93.1032C55.2484 93.7263 53.6578 93.1676 53.0345 91.8355C52.4111 90.5247 52.97 88.9347 54.3027 88.3116Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M59.4614 92.9313C59.9343 91.5561 59.2034 90.052 57.8278 89.5578C56.4521 89.0851 54.9476 89.8157 54.4532 91.1908C53.9804 92.566 54.7111 94.0701 56.0867 94.5643C57.4624 95.037 58.967 94.3065 59.4614 92.9313Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1152 309.241L0.265266 237.087L0.587738 236.765L85.47 152.665L45.0815 308.832L43.9423 308.532L83.256 156.511L1.72688 237.281L43.1255 308.639L42.1152 309.241Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M47.102 309.219C46.7366 310.637 45.2964 311.475 43.8778 311.11C42.4591 310.745 41.6208 309.305 41.9863 307.887C42.3517 306.469 43.7918 305.631 45.2104 305.996C46.6291 306.361 47.4674 307.801 47.102 309.219Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M40.2667 310.143C40.9976 311.411 42.6311 311.841 43.8778 311.11C45.146 310.379 45.5759 308.746 44.8451 307.5C44.1143 306.233 42.4807 305.803 41.234 306.533C39.9658 307.264 39.5359 308.897 40.2667 310.143Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M43.9423 308.532L84.0083 153.611L191.008 233.392L46.3712 310.444L45.8338 309.413L188.816 233.22L84.7176 155.587L45.0815 308.833L43.9423 308.532Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4675 312.206C46.1778 312.893 44.5656 312.399 43.8778 311.11C43.1899 309.821 43.6843 308.209 44.974 307.522C46.2637 306.834 47.8757 307.328 48.5636 308.617C49.2514 309.907 48.7571 311.518 47.4675 312.206Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9863 307.887C41.6209 309.305 42.4807 310.745 43.8779 311.11C45.2965 311.475 46.7366 310.616 47.102 309.219C47.4675 307.823 46.6077 306.362 45.2105 305.996C43.7919 305.631 42.3517 306.49 41.9863 307.887Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5896 154.427L181.293 129.717L184.818 197.573L183.636 197.637L180.175 131.2L86.1363 154.749L182.303 198.518L181.83 199.593L82.5896 154.427Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M183.034 196.606C184.367 197.208 184.947 198.776 184.345 200.108C183.743 201.441 182.174 202.021 180.841 201.419C179.509 200.817 178.928 199.249 179.53 197.917C180.132 196.584 181.701 196.004 183.034 196.606Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M181.572 197.594C181.658 199.056 182.883 200.173 184.345 200.108C185.807 200.044 186.924 198.798 186.86 197.337C186.795 195.875 185.549 194.758 184.087 194.823C182.625 194.909 181.508 196.133 181.572 197.594Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.36
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M79.6233 151.784L182.303 198.518L181.83 199.593L89.1025 157.392L189.095 231.952L184.195 202.687L185.355 202.493L190.729 234.638L79.6233 151.784Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.53
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M183.034 196.606C184.367 197.208 184.947 198.776 184.345 200.108C183.743 201.441 182.174 202.021 180.841 201.419C179.509 200.817 178.928 199.249 179.53 197.917C180.132 196.584 181.701 196.004 183.034 196.606Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M187.397 202.279C187.161 200.839 185.785 199.872 184.345 200.108C182.905 200.345 181.938 201.72 182.174 203.159C182.411 204.599 183.786 205.566 185.226 205.33C186.667 205.093 187.634 203.718 187.397 202.279Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M289.088 379.267L279.631 328.837L278.47 329.052L287.906 379.267H289.088Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M239.608 379.267L189.418 355.416L276.364 327.806L276.02 326.667L186.237 355.18L236.878 379.267H239.608Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M275.267 324.754C276.664 324.303 278.148 325.077 278.599 326.473C279.05 327.87 278.277 329.353 276.879 329.804C275.482 330.255 273.999 329.482 273.548 328.085C273.096 326.688 273.87 325.206 275.267 324.754Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M281.673 328.579C281.393 327.139 280.018 326.194 278.578 326.473C277.137 326.753 276.192 328.128 276.471 329.568C276.751 331.007 278.126 331.953 279.566 331.673C281.006 331.394 281.952 330.019 281.673 328.579Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M289.088 379.267L279.459 327.977L295.902 341.708L296.654 340.805L277.718 324.969L287.906 379.267H289.088Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M296.01 379.267L298.589 345.425L297.428 345.339L294.827 379.267H296.01Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M295.365 345.296C295.472 343.835 296.74 342.739 298.202 342.868C299.664 342.975 300.76 344.243 300.631 345.704C300.502 347.165 299.255 348.261 297.794 348.132C296.332 348.025 295.236 346.757 295.365 345.296Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.67
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M294.462 343.212C295.58 344.157 297.256 344.007 298.202 342.889C299.148 341.772 298.997 340.096 297.88 339.172C296.762 338.248 295.085 338.377 294.14 339.494C293.194 340.612 293.344 342.288 294.462 343.233V343.212Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M186.967 356.19L197.285 320.113L276.127 325.721L276.041 326.796L276.364 327.806L186.946 356.19H186.967ZM198.145 321.338L188.687 354.407L275.482 326.839L198.123 321.338H198.145Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M276.127 323.637C277.589 323.744 278.685 325.012 278.577 326.473C278.47 327.934 277.202 329.03 275.74 328.923C274.279 328.815 273.182 327.547 273.29 326.086C273.397 324.625 274.665 323.529 276.127 323.637Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M276.879 329.804C278.277 329.353 279.05 327.87 278.599 326.473C278.148 325.077 276.664 324.303 275.267 324.754C273.87 325.206 273.096 326.688 273.548 328.085C273.999 329.482 275.482 330.255 276.879 329.804Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M338.526 379.267H340.912L345.813 376.495L345.232 375.464L338.526 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M319.568 379.267L329.176 369.297L345.146 374.518L345.512 373.401L328.853 367.965L317.934 379.267H319.568Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.14
  }, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M344.093 373.745C345.361 373.014 346.973 373.465 347.704 374.733C348.435 376.001 347.984 377.612 346.715 378.343C345.447 379.073 343.835 378.622 343.104 377.354C342.374 376.087 342.825 374.475 344.093 373.745Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M344.373 376.43C345.77 376.882 347.253 376.13 347.704 374.733C348.156 373.336 347.403 371.854 346.006 371.402C344.609 370.951 343.126 371.703 342.675 373.1C342.223 374.497 342.975 375.979 344.373 376.43Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M340.912 379.267L345.705 376.559L343.771 379.267H345.211L346.737 377.118L345.791 376.474L345.232 375.464L338.526 379.267H340.912Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M344.093 373.745C345.361 373.014 346.973 373.465 347.704 374.733C348.435 376.001 347.984 377.612 346.715 378.343C345.447 379.073 343.835 378.622 343.104 377.354C342.374 376.087 342.825 374.475 344.093 373.745Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M361.332 379.267L350.262 375.077L349.854 376.173L358.022 379.267H361.332Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.17
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M351.122 373.208C349.746 372.692 348.22 373.379 347.704 374.755C347.188 376.13 347.876 377.655 349.252 378.171C350.628 378.687 352.154 377.999 352.67 376.624C353.185 375.249 352.498 373.723 351.122 373.208Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M306.069 379.267H307.402L316.172 361.97L300.309 344.35L299.449 345.124L314.753 362.163L306.069 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M296.01 379.267L298.589 345.425L297.428 345.339L294.827 379.267H296.01Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.47
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M295.365 345.296C295.472 343.835 296.74 342.739 298.202 342.868C299.664 342.975 300.76 344.243 300.631 345.704C300.502 347.165 299.255 348.261 297.794 348.132C296.332 348.025 295.236 346.757 295.365 345.296Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.05
  }, _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M301.942 343.061C300.975 341.965 299.298 341.879 298.202 342.868C297.106 343.856 297.02 345.511 298.009 346.606C298.976 347.702 300.653 347.788 301.749 346.8C302.845 345.811 302.931 344.157 301.942 343.061Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M307.402 379.267L314.86 364.57L313.807 364.033L306.069 379.267H307.402Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M317.934 379.267H319.568L329.993 368.459L317.977 362.636L317.483 363.689L328.037 368.803L317.934 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M311.916 363.216C312.582 361.905 314.173 361.39 315.484 362.056C316.795 362.722 317.311 364.312 316.645 365.623C315.978 366.933 314.388 367.449 313.076 366.783C311.765 366.117 311.249 364.527 311.916 363.216Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M319.009 360.831C317.698 360.187 316.107 360.745 315.462 362.056C314.817 363.367 315.376 364.957 316.687 365.601C317.999 366.246 319.589 365.687 320.234 364.376C320.879 363.066 320.32 361.476 319.009 360.831Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M84.5026 155.157L84.1372 154.062L171.663 115.944L172.136 117.018L91.1015 152.3L179.917 130.061L174.672 118.028L175.747 117.555L181.551 130.856L180.884 131.028L84.5026 155.157Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M170.718 114.117C172.05 113.537 173.619 114.139 174.2 115.493C174.78 116.825 174.178 118.393 172.824 118.973C171.491 119.554 169.922 118.952 169.342 117.598C168.762 116.266 169.363 114.698 170.718 114.117Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M177.703 116.846C177.123 115.514 175.554 114.891 174.221 115.471C172.889 116.051 172.265 117.62 172.846 118.952C173.426 120.284 174.995 120.907 176.328 120.327C177.66 119.747 178.284 118.178 177.703 116.846Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M189.547 234.659L184.195 202.687L185.355 202.493L190.278 231.952L200.853 219.318L185.592 202.364L186.473 201.591L202.401 219.296L189.547 234.659Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M182.174 203.159C181.938 201.72 182.905 200.345 184.345 200.108C185.785 199.872 187.161 200.839 187.397 202.279C187.634 203.718 186.667 205.093 185.226 205.33C183.786 205.566 182.411 204.599 182.174 203.159Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M188.085 200.302C187.118 199.206 185.441 199.12 184.345 200.108C183.249 201.075 183.163 202.751 184.152 203.847C185.119 204.943 186.796 205.029 187.892 204.04C188.988 203.074 189.074 201.398 188.085 200.302Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M189.074 233.37L199.563 220.843L200.466 221.595L190.729 233.22L200.552 241.428L200.982 221.81L202.143 221.832L201.67 243.899L189.074 233.37Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.58
  }, _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M197.887 219.64C198.832 218.523 200.488 218.372 201.605 219.318C202.723 220.263 202.873 221.918 201.928 223.035C200.982 224.152 199.327 224.303 198.209 223.357C197.091 222.412 196.941 220.757 197.887 219.64Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M204.206 222.004C204.228 220.542 203.088 219.339 201.627 219.296C200.165 219.253 198.961 220.413 198.918 221.875C198.897 223.336 200.036 224.539 201.498 224.582C202.959 224.625 204.163 223.465 204.206 222.004Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M45.447 313.173L46.1992 312.271L80.2681 340.762L186.624 235.712L46.3712 310.444L45.8338 309.413L193.179 230.899L80.3327 342.352L45.447 313.173Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M47.4675 312.206C46.1778 312.893 44.5656 312.399 43.8778 311.11C43.1899 309.821 43.6843 308.209 44.974 307.522C46.2637 306.834 47.8757 307.328 48.5636 308.617C49.2514 309.907 48.7571 311.518 47.4675 312.206Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M47.6179 310.788C46.5001 309.842 44.8236 309.993 43.8778 311.11C42.9321 312.227 43.0826 313.903 44.2003 314.849C45.318 315.794 46.9946 315.644 47.9403 314.526C48.8861 313.409 48.7356 311.733 47.6179 310.788Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M78.1401 342.868L187.698 234.659L188.537 235.476L82.4606 340.247L190.6 305.33L189.375 235.82L190.536 235.798L191.782 306.19L191.374 306.319L78.1401 342.868Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M187.311 235.992C187.29 234.531 188.45 233.327 189.912 233.306C191.374 233.284 192.577 234.445 192.599 235.906C192.62 237.367 191.46 238.57 189.998 238.592C188.536 238.613 187.333 237.453 187.311 235.992Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M189.891 237.044C190.922 236.013 190.944 234.337 189.912 233.306C188.88 232.274 187.204 232.253 186.172 233.284C185.14 234.316 185.119 235.992 186.151 237.023C187.182 238.054 188.859 238.076 189.891 237.044Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99998 236.894L-0.616139 237.603L-6.99998 242.137V243.577L2.58667 236.765L-6.99998 235.734V236.894Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M-7.00001 243.577L0.802547 238.033L42.6096 310.1L-7.00001 294.221V295.468L43.7059 311.669L45.1675 312.142L1.49039 236.894L1.16792 236.336L-7.00001 242.137V243.577Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99995 1.86925L41.1694 61.775L-6.99995 59.218V60.3998L43.7273 63.0857L-6.99995 -0.000106812V1.86925Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M200.509 243.104L200.982 221.81L202.143 221.832L201.713 242.244L226.045 249.55L202.787 221.617L203.69 220.865L229.441 251.784L200.509 243.104Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M198.918 221.896C198.94 220.435 200.165 219.275 201.627 219.318C203.088 219.361 204.249 220.564 204.206 222.025C204.185 223.486 202.959 224.647 201.498 224.604C200.036 224.561 198.875 223.357 198.918 221.896Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.07
  }, _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M205.345 219.64C204.4 218.523 202.745 218.372 201.627 219.296C200.509 220.242 200.359 221.896 201.283 223.013C202.229 224.131 203.884 224.281 205.001 223.357C206.119 222.412 206.27 220.757 205.345 219.64Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M190.192 308.317L200.638 241.922L225.507 249.378L225.185 250.495L201.584 243.426L192.191 303.203L225.873 252.429L226.862 253.074L190.192 308.317Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M225.98 247.358C227.377 247.788 228.173 249.249 227.764 250.646C227.334 252.042 225.873 252.837 224.476 252.429C223.078 251.999 222.283 250.538 222.691 249.142C223.121 247.745 224.583 246.95 225.98 247.358Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M197.715 322.198L190.514 305.695L190.686 305.438L225.873 252.429L226.561 252.88L227.313 253.203L197.715 322.198ZM191.847 305.803L197.693 319.232L224.647 256.361L191.825 305.803H191.847Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1
  }, _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M224.089 251.398C224.906 250.173 226.539 249.851 227.764 250.646C228.99 251.462 229.312 253.095 228.517 254.32C227.7 255.545 226.066 255.867 224.841 255.072C223.616 254.277 223.293 252.623 224.089 251.398Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M229.14 254.148C229.72 252.794 229.097 251.247 227.743 250.667C226.389 250.087 224.841 250.71 224.261 252.064C223.68 253.417 224.304 254.964 225.658 255.545C226.99 256.125 228.56 255.502 229.14 254.148Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M196.833 321.252L226.217 252.751L227.291 253.203L198.575 320.199L277.438 325.807L228.667 253.074L229.634 252.429L279.738 327.139L196.833 321.252Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M224.282 252.042C224.862 250.689 226.41 250.087 227.764 250.646C229.097 251.226 229.72 252.773 229.161 254.127C228.602 255.48 227.033 256.082 225.679 255.523C224.325 254.943 223.723 253.396 224.282 252.042Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M231.418 251.398C230.601 250.173 228.968 249.851 227.743 250.667C226.517 251.484 226.195 253.117 227.012 254.342C227.829 255.545 229.462 255.889 230.687 255.072C231.891 254.256 232.235 252.623 231.418 251.398Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.54
  }, _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M58.0858 159.885L57.2259 88.9132L81.5579 91.5776L81.4504 92.7379L58.4296 90.2239L59.2034 153.89L82.5465 94.5429L83.6213 94.9726L58.0858 159.885Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M80.5691 93.9196C81.1065 92.566 82.6327 91.8999 84.0083 92.4156C85.3625 92.9527 86.0287 94.4783 85.5128 95.8535C84.9755 97.2072 83.4494 97.8733 82.0737 97.3576C80.7196 96.8204 80.0532 95.2948 80.5691 93.9196Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.21
  }, _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M81.085 94.7577C82.5466 94.9081 83.8364 93.8552 84.0083 92.4156C84.1588 90.9545 83.1055 89.6653 81.6654 89.4934C80.2037 89.343 78.9141 90.3958 78.7421 91.8354C78.5702 93.2751 79.6448 94.5858 81.085 94.7577Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.19
  }, _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0782 168.093L56.4522 91.7494L57.4193 92.0932H58.4512L59.2465 157.285L58.8596 157.435L30.0998 168.114L30.0782 168.093ZM57.269 92.9312L31.9913 166.116L58.0428 156.447L57.269 92.9097V92.9312Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4532 91.2123C54.9261 89.8372 56.4306 89.1066 57.8278 89.5793C59.2034 90.052 59.9343 91.5561 59.4614 92.9528C58.9885 94.3279 57.4839 95.0585 56.0867 94.5858C54.7111 94.1131 53.9804 92.609 54.4532 91.2123Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5145 92.1792C60.5145 90.7181 59.2893 89.5578 57.8277 89.5578C56.3661 89.5578 55.2054 90.7826 55.2054 92.2437C55.2054 93.7048 56.4306 94.8651 57.8922 94.8651C59.3539 94.8651 60.5145 93.6404 60.5145 92.1792Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7419 157.543L82.5252 94.5428L83.5139 94.9295H84.5886L84.9326 155.115L57.7204 157.543H57.7419ZM83.428 95.4667L59.526 156.21L83.7718 154.04L83.428 95.4452V95.4667Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M85.4914 95.8536C86.0288 94.4999 85.3624 92.9528 83.9868 92.4157C82.6326 91.8785 81.0849 92.5446 80.5475 93.9198C80.0102 95.2734 80.6765 96.8205 82.0522 97.3577C83.4064 97.8949 84.954 97.2288 85.4914 95.8536Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M-1.66932 241.901L29.4979 169.21L30.5941 169.661L3.63992 232.468L57.054 158.101L33.6034 166.804L33.195 165.708L60.2353 155.673L-1.66932 241.901Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5931 163.71C31.2174 164.225 30.5296 165.751 31.024 167.104C31.5184 168.458 33.066 169.167 34.4202 168.673C35.7959 168.157 36.4836 166.632 35.9893 165.278C35.4734 163.903 33.9472 163.215 32.5931 163.71Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M1.98482 234.81L58.3223 156.339L85.9428 153.868L84.7821 155.007L3.18851 235.82L2.62963 235.261L1.98482 234.788V234.81ZM58.9671 157.457L5.553 231.845L82.8047 155.33L58.9671 157.457Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M4.73614 237.195C3.7044 238.226 2.02771 238.226 0.995969 237.195C-0.0357733 236.164 -0.0357733 234.488 0.995969 233.456C2.02771 232.425 3.7044 232.425 4.73614 233.456C5.76788 234.488 5.76788 236.164 4.73614 237.195Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M0.394148 233.499C-0.465637 234.681 -0.186275 236.335 0.995929 237.195C2.17813 238.054 3.83329 237.775 4.69307 236.593C5.55286 235.411 5.27336 233.757 4.09116 232.897C2.90896 232.038 1.25393 232.317 0.394148 233.499Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99996 115.278V116.653L49.9393 81.5646L49.316 80.5762L-6.99996 115.278Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99994 61.818L49.187 79.5448L49.5309 78.4275L-6.99994 60.5718V61.818Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.41
  }, _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0467 76.4291C51.4439 76.8589 52.2178 78.363 51.7664 79.7596C51.3365 81.1563 49.8318 81.9298 48.4346 81.4786C47.0375 81.0488 46.2637 79.5447 46.7151 78.1481C47.145 76.7514 48.6496 75.9779 50.0467 76.4291Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M50.9065 83.391C52.1532 82.6174 52.5401 80.9844 51.7663 79.7597C50.9925 78.5349 49.3589 78.1267 48.1337 78.9002C46.8871 79.6737 46.5001 81.3067 47.2739 82.5315C48.0477 83.7777 49.6813 84.1645 50.9065 83.391Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99994 61.818L49.187 79.5448L49.5309 78.4275L-6.99994 60.5933V61.818Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99992 60.4L42.0723 62.9999L50.0468 77.8044L51.1001 77.2458L42.8031 61.8611L-6.99992 59.2182V60.4Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M50.0467 76.4291C51.4439 76.8589 52.2178 78.363 51.7664 79.7596C51.3365 81.1563 49.8318 81.9298 48.4346 81.4786C47.0375 81.0488 46.2637 79.5447 46.7151 78.1481C47.145 76.7514 48.6496 75.9779 50.0467 76.4291Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1767 78.6639C48.8645 79.9532 50.4767 80.4259 51.7663 79.7383C53.056 79.0507 53.5289 77.4391 52.8411 76.1499C52.1533 74.8607 50.5411 74.388 49.2514 75.0756C47.9617 75.7632 47.4888 77.3747 48.1767 78.6639Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1123 78.8788C49.359 78.1053 50.9926 78.4921 51.7449 79.7383C52.4972 80.9846 52.1317 82.6176 50.885 83.3696C49.6383 84.1431 48.0047 83.7564 47.2524 82.5101C46.4786 81.2639 46.8656 79.6309 48.1123 78.8788Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M55.399 80.6193C54.6252 79.373 52.9916 78.9863 51.7664 79.7598C50.5197 80.5333 50.1327 82.1664 50.9065 83.3911C51.6803 84.6374 53.3139 85.0241 54.5391 84.2506C55.7858 83.4771 56.1728 81.844 55.399 80.6193Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.62
  }, _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M189.633 379.267L188.537 357.78L187.376 357.844L188.451 379.267H189.633Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.62
  }, _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M165.236 379.267L186.495 357.501L185.656 356.684L163.603 379.267H165.236Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M185.312 358.081C185.248 356.62 186.366 355.373 187.827 355.309C189.289 355.244 190.536 356.362 190.6 357.823C190.664 359.284 189.547 360.53 188.085 360.595C186.624 360.659 185.377 359.542 185.312 358.081Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M187.87 359.048C188.902 357.995 188.881 356.319 187.827 355.309C186.774 354.278 185.097 354.299 184.087 355.352C183.055 356.405 183.077 358.081 184.13 359.091C185.183 360.101 186.86 360.101 187.87 359.048Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.31
  }, _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M97.3778 379.267L81.3214 342.438L153.371 361.132L131.812 379.267H133.639L155.865 360.573L79.2793 340.698L96.0882 379.267H97.3778Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M83.6429 343.255C82.2457 343.706 80.7626 342.932 80.3113 341.557C79.8599 340.161 80.6336 338.678 82.0093 338.227C83.4064 337.775 84.8897 338.549 85.3411 339.924C85.7924 341.321 85.0186 342.803 83.6429 343.255Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M83.5354 339.666C82.1168 339.301 80.6766 340.139 80.3112 341.557C79.9458 342.975 80.7841 344.415 82.2027 344.78C83.6214 345.146 85.0615 344.308 85.4269 342.889C85.7923 341.471 84.954 340.032 83.5354 339.666Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M133.639 379.267L154.038 362.12L153.995 379.267H155.177L155.198 359.585L131.812 379.267H133.639Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M151.372 364.656L189.31 307.522L190.278 308.166L157.864 357.028L197.005 320.586L191.653 308.295L192.728 307.823L198.403 320.865L151.372 364.656Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.52
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M189.805 309.241C189.224 307.909 189.826 306.34 191.18 305.76C192.513 305.18 194.082 305.781 194.662 307.135C195.243 308.467 194.641 310.036 193.287 310.616C191.954 311.196 190.385 310.595 189.805 309.241Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M191.933 309.434C192.75 308.21 192.406 306.577 191.18 305.76C189.955 304.944 188.322 305.287 187.505 306.512C186.688 307.737 187.032 309.37 188.257 310.186C189.482 311.003 191.116 310.659 191.933 309.434Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M152.791 361.755L195.458 322.004L196.275 322.863L156.445 359.95L187.376 354.772L196.447 322.971L197.586 323.315L188.3 355.824L187.913 355.867L152.791 361.755Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M194.426 322.541C194.834 321.145 196.296 320.328 197.693 320.715C199.09 321.123 199.907 322.584 199.52 323.981C199.112 325.378 197.65 326.194 196.253 325.807C194.856 325.399 194.039 323.938 194.426 322.541Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M197.564 324.475C198.639 323.487 198.703 321.811 197.693 320.736C196.704 319.662 195.028 319.597 193.953 320.607C192.878 321.596 192.814 323.272 193.824 324.346C194.834 325.42 196.49 325.485 197.564 324.475Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.55
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M155.177 379.267L155.198 361.347L186.151 356.168L163.603 379.267H165.258L189.504 354.428L154.038 360.358L153.995 379.267H155.177Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7933 156.189L83.7718 154.599L83.4279 94.951L84.6101 94.9296L84.9541 152.987L143.806 82.639L86.5876 92.566L86.3942 91.4272L146.751 80.92L83.7933 156.189Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M81.3643 95.08C81.3643 93.6189 82.5251 92.4371 83.9867 92.4156C85.4484 92.4156 86.6306 93.5759 86.6521 95.037C86.6735 96.4981 85.4913 97.7014 84.0296 97.7014C82.568 97.7014 81.3643 96.5411 81.3643 95.08Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M86.1577 89.3645C84.7176 89.6223 83.7503 90.976 84.0083 92.4156C84.2662 93.8553 85.6203 94.8222 87.0605 94.5643C88.5006 94.3065 89.4679 92.9528 89.2099 91.5132C88.952 90.0735 87.5979 89.1066 86.1577 89.3645Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M82.3316 156.125L143.226 83.3266L144.107 84.0786L86.4157 153.052L173.254 115.256L146.472 84.0786L147.353 83.3051L175.167 115.707L174.458 116.03L82.3316 156.125Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M141.549 82.1019C142.495 80.9846 144.15 80.8342 145.289 81.7796C146.429 82.725 146.557 84.3795 145.612 85.5183C144.666 86.6356 143.011 86.7861 141.872 85.8406C140.754 84.8952 140.603 83.2407 141.549 82.1234V82.1019Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M149.008 82.0587C148.062 80.9414 146.386 80.8125 145.268 81.7794C144.15 82.7249 144.021 84.4008 144.988 85.5182C145.934 86.6355 147.611 86.7644 148.728 85.7975C149.846 84.8521 149.975 83.1761 149.008 82.0587Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M50.4122 366.482L50.842 365.128L50.7776 363.689L113.241 360.81L71.4769 373.057L71.2405 372.993L50.4122 366.482ZM99.7853 363.066L51.9813 365.279L71.4985 371.381L99.8068 363.087L99.7853 363.066Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1645 368.158C49.144 368.244 47.4245 366.676 47.3385 364.656C47.2526 362.636 48.8 360.917 50.842 360.831C52.8625 360.745 54.5822 362.314 54.6681 364.334C54.7541 366.353 53.185 368.072 51.1645 368.158Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M51.9168 362.249C49.9823 361.647 47.9189 362.722 47.317 364.656C46.7152 366.589 47.7899 368.652 49.7244 369.254C51.6589 369.855 53.7225 368.781 54.3243 366.847C54.9262 364.913 53.8513 362.851 51.9168 362.249Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.35
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99993 240.826L2.39321 250.302L-6.99993 261.11V263.602L4.6286 250.216L-6.99993 238.505V240.826Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99997 263.602L3.23149 251.806L45.8338 363.066L-6.99997 338.313V340.117L48.8001 366.246L4.26319 249.958L3.79037 248.712L-6.99997 261.11V263.602Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M47.188 366.59L46.5646 364.957L4.00524 253.804L5.50989 253.224L47.4674 362.743L106.363 257.006L6.95 251.269L7.03606 249.657L109.049 255.545L47.188 366.59Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M7.38 246.8C5.35951 246.692 3.61847 248.218 3.511 250.259C3.40352 252.279 4.92961 254.019 6.9716 254.127C8.99209 254.234 10.7331 252.709 10.8406 250.667C10.9481 248.626 9.42199 246.907 7.38 246.8Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M50.842 365.322L50.7561 363.689L105.718 361.153L106.857 259.477L49.7243 362.013L48.3056 361.218L108.555 253.074L107.308 362.722L106.556 362.743L50.842 365.322Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M51.1645 368.158C49.144 368.244 47.4245 366.676 47.3385 364.656C47.2526 362.636 48.8 360.917 50.842 360.831C52.8625 360.745 54.5822 362.314 54.6681 364.334C54.7541 366.353 53.185 368.072 51.1645 368.158Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8983 359.671C44.9096 361.432 45.5545 363.667 47.317 364.656C49.0796 365.644 51.3151 364.999 52.3038 363.237C53.2926 361.475 52.6476 359.241 50.8851 358.252C49.1225 357.264 46.8871 357.909 45.8983 359.671Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M385.707 348.927L344.824 255.222L362.514 260.745L362.041 262.292L347.726 257.844L383.471 339.709L365.631 266.138L367.221 265.751L387.254 348.412L385.707 348.927Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M362.901 266.997C362.428 265.021 363.632 263.044 365.609 262.571C367.587 262.098 369.564 263.302 370.037 265.278C370.51 267.255 369.306 269.232 367.329 269.705C365.351 270.177 363.374 268.974 362.901 266.997Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M361.009 264.977C362.944 265.579 365.007 264.505 365.609 262.571C366.211 260.637 365.136 258.574 363.202 257.973C361.267 257.371 359.204 258.445 358.602 260.379C358 262.313 359.075 264.376 361.009 264.977Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M1.76995 250.968L97.7864 144.801L98.9901 145.897L5.25207 249.55L106.836 255.416L100.129 146.305L101.763 146.197L108.577 257.135L107.652 257.092L1.76995 250.968Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.7
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M95.5509 143.017C96.9051 141.513 99.2265 141.406 100.731 142.76C102.236 144.113 102.343 146.434 100.989 147.938C99.6348 149.442 97.3135 149.549 95.8089 148.196C94.3042 146.842 94.1968 144.521 95.5509 143.017Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M104.622 146.197C104.493 144.178 102.751 142.631 100.731 142.76C98.7105 142.888 97.1629 144.629 97.2919 146.649C97.4209 148.668 99.1619 150.216 101.182 150.087C103.203 149.958 104.75 148.217 104.622 146.197Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.4
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M130.587 379.267L107.502 361.669L168.912 214.934L192.212 379.267H193.846L169.686 208.854L105.761 361.626L105.524 362.206L127.9 379.267H130.587Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M193.846 379.267L170.266 212.979L344.845 257.006L244.444 379.267H246.551L347.726 256.06L168.332 210.809L192.212 379.267H193.846Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M166.956 212.614L280.125 128.514L320.729 213.495L319.267 214.204L279.502 130.985L171.642 211.153L318.042 216.052L317.999 217.685L166.956 212.614Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M317.956 213.194C319.976 213.258 321.567 214.956 321.502 216.976C321.438 218.995 319.74 220.585 317.719 220.521C315.699 220.456 314.108 218.759 314.173 216.739C314.237 214.719 315.935 213.129 317.956 213.194Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.16
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M316.623 215.257C317.504 217.083 319.697 217.857 321.524 216.976C323.351 216.095 324.125 213.903 323.243 212.077C322.362 210.25 320.17 209.477 318.343 210.358C316.515 211.239 315.742 213.43 316.623 215.257Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.36
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M161.754 210.809L318.042 216.052L317.999 217.685L176.843 212.958L344.523 255.244L322.663 220.371L324.039 219.511L348.048 257.823L161.754 210.809Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.53
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M317.956 213.194C319.976 213.258 321.567 214.956 321.502 216.976C321.438 218.995 319.74 220.585 317.719 220.521C315.699 220.456 314.108 218.759 314.173 216.739C314.237 214.719 315.935 213.129 317.956 213.194Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M326.575 218.158C325.5 216.439 323.243 215.923 321.524 216.997C319.804 218.072 319.288 220.328 320.363 222.047C321.438 223.766 323.695 224.281 325.414 223.207C327.134 222.133 327.65 219.876 326.575 218.158Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M543.456 379.267L511.966 331.115L510.59 332.017L541.521 379.267H543.456Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M450.685 379.267L507.237 331.523L506.184 330.277L448.17 379.267H450.685Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M504.207 328.214C505.754 326.903 508.076 327.096 509.387 328.644C510.698 330.191 510.505 332.511 508.957 333.822C507.409 335.133 505.088 334.939 503.777 333.392C502.466 331.845 502.659 329.525 504.207 328.214Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M514.459 329.718C513.342 328.02 511.085 327.548 509.387 328.665C507.689 329.782 507.216 332.038 508.334 333.736C509.451 335.433 511.708 335.906 513.406 334.789C515.104 333.671 515.577 331.415 514.459 329.718Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M557.234 379.267L545.068 342.266L543.52 342.76L555.514 379.267H557.234Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M543.456 379.267L511.3 330.105L539.63 338.936L540.103 337.389L507.452 327.204L541.521 379.267H543.456Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M540.855 343.835C540.232 341.901 541.263 339.838 543.198 339.194C545.132 338.549 547.196 339.602 547.841 341.536C548.464 343.47 547.432 345.532 545.498 346.177C543.563 346.8 541.5 345.769 540.855 343.835Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.67
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M538.598 341.622C540.532 342.223 542.596 341.149 543.198 339.215C543.8 337.281 542.725 335.218 540.79 334.617C538.856 334.015 536.792 335.089 536.191 337.023C535.589 338.957 536.663 341.02 538.598 341.622Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M755.995 379.267L748.471 352.859L746.924 353.311L754.318 379.267H755.995Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.34
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M713.027 379.267L744.602 352.601L743.549 351.355L710.512 379.267H713.027Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.46
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M744.215 354.256C743.657 352.301 744.796 350.281 746.73 349.722C748.686 349.164 750.707 350.302 751.266 352.236C751.825 354.191 750.685 356.211 748.751 356.77C746.816 357.329 744.774 356.19 744.215 354.256Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.2
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M746.3 354.901C747.848 353.59 748.041 351.269 746.73 349.722C745.419 348.175 743.098 347.982 741.55 349.292C740.002 350.603 739.809 352.924 741.12 354.471C742.431 356.018 744.753 356.211 746.3 354.901Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M755.995 379.267L748.192 351.806L785.27 379.267H788L745.312 347.659L754.318 379.267H755.995Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M405.331 379.267L403.655 364.849L505.604 330.771L448.17 379.267H450.685L507.237 331.523L506.27 330.384L505.819 328.987L401.892 363.732L403.698 379.267H405.331Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M504.722 326.323C506.636 325.678 508.72 326.71 509.365 328.644C510.01 330.556 508.978 332.64 507.044 333.285C505.109 333.929 503.046 332.898 502.401 330.964C501.756 329.052 502.788 326.968 504.722 326.323Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M508.935 333.822C510.483 332.511 510.676 330.191 509.365 328.644C508.054 327.096 505.733 326.903 504.185 328.214C502.637 329.525 502.444 331.845 503.755 333.392C505.066 334.939 507.388 335.133 508.935 333.822Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M604.629 379.267L622.04 356.92L620.75 355.932L602.587 379.267H604.629Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M588.014 379.267L596.913 356.577L620.106 354.772L619.998 353.139L595.774 355.03L586.273 379.267H588.014Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.14
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M618.386 354.32C619.633 352.73 621.933 352.43 623.545 353.676C625.135 354.922 625.436 357.221 624.189 358.833C622.943 360.423 620.643 360.724 619.031 359.477C617.44 358.231 617.139 355.932 618.386 354.32Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M620.149 357.629C622.169 357.479 623.674 355.717 623.523 353.676C623.373 351.656 621.61 350.152 619.568 350.302C617.548 350.453 616.043 352.236 616.194 354.256C616.344 356.276 618.128 357.78 620.127 357.629H620.149Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M604.629 379.267L621.933 357.071L616.903 379.267H618.558L623.545 357.264L621.997 356.899L620.75 355.932L602.587 379.267H604.629Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.63
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M618.386 354.32C619.633 352.73 621.933 352.43 623.545 353.676C625.135 354.922 625.436 357.221 624.189 358.833C622.943 360.423 620.643 360.724 619.031 359.477C617.44 358.231 617.139 355.932 618.386 354.32Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M626.296 358.081C626.747 356.104 625.501 354.149 623.523 353.698C621.546 353.246 619.59 354.493 619.138 356.469C618.687 358.446 619.934 360.401 621.911 360.853C623.889 361.304 625.845 360.058 626.296 358.081Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M744.43 350.625L710.512 379.267H713.027L749.052 348.841L626.984 352.752L627.048 354.385L744.43 350.625Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.13
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M618.558 379.267L623.545 357.264L621.976 356.899L616.903 379.267H618.558Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.44
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M619.138 356.448C619.59 354.471 621.546 353.225 623.523 353.676C625.501 354.127 626.747 356.082 626.296 358.059C625.845 360.036 623.889 361.282 621.911 360.831C619.934 360.38 618.687 358.424 619.138 356.448Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.17
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M627.091 349.894C625.071 349.959 623.48 351.656 623.545 353.676C623.609 355.696 625.307 357.286 627.328 357.221C629.348 357.157 630.939 355.459 630.874 353.44C630.81 351.42 629.112 349.83 627.091 349.894Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M572.817 379.267H574.451L576.364 354.106L546.701 339.967L545.992 341.45L574.666 355.094L572.817 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M557.234 379.267L545.068 342.266L543.52 342.76L555.514 379.267H557.234Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.47
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M540.855 343.835C540.232 341.901 541.263 339.838 543.198 339.194C545.132 338.549 547.196 339.602 547.841 341.536C548.464 343.47 547.432 345.532 545.498 346.177C543.563 346.8 541.5 345.769 540.855 343.835Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.05
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M548.099 337.475C546.272 336.594 544.079 337.389 543.198 339.215C542.317 341.041 543.112 343.233 544.939 344.114C546.766 344.995 548.958 344.2 549.84 342.374C550.721 340.547 549.926 338.356 548.099 337.475Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M574.451 379.267L576.063 358.145L574.429 358.016L572.817 379.267H574.451Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.06
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M586.273 379.267H588.014L597.515 355.051L579.029 353.977L578.943 355.61L595.193 356.555L586.273 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.39
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M571.571 357.973C571.721 355.953 573.484 354.449 575.504 354.6C577.525 354.75 579.029 356.512 578.879 358.532C578.728 360.551 576.966 362.056 574.945 361.905C572.925 361.755 571.42 359.993 571.571 357.973Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M579.395 351.14C577.374 351.033 575.633 352.558 575.526 354.6C575.418 356.641 576.944 358.36 578.986 358.467C581.007 358.575 582.748 357.049 582.855 355.008C582.963 352.967 581.437 351.248 579.395 351.14Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M169.793 212.528L168.719 211.325L260.501 116.008L261.661 117.126L176.693 205.373L278.556 129.674L265.444 117.061L266.584 115.879L281.071 129.824L280.297 130.405L169.793 212.528Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M258.308 114.16C259.705 112.699 262.027 112.656 263.488 114.053C264.95 115.45 264.993 117.77 263.596 119.231C262.199 120.692 259.856 120.735 258.416 119.339C256.954 117.942 256.911 115.6 258.308 114.16Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M268.69 113.946C267.228 112.549 264.907 112.592 263.51 114.053C262.113 115.514 262.156 117.835 263.617 119.231C265.079 120.628 267.4 120.585 268.797 119.124C270.195 117.663 270.152 115.342 268.69 113.946Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M346.522 258.467L322.663 220.371L324.039 219.511L346.028 254.599L352.842 232.812L324.297 219.21L325.006 217.749L354.819 231.952L346.522 258.467Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M320.342 222.047C319.267 220.328 319.783 218.072 321.502 216.997C323.222 215.923 325.479 216.439 326.554 218.158C327.628 219.876 327.112 222.133 325.393 223.207C323.673 224.281 321.416 223.766 320.342 222.047Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M326.403 215.257C324.576 214.376 322.384 215.171 321.502 216.997C320.621 218.824 321.416 221.015 323.243 221.896C325.07 222.777 327.263 221.982 328.144 220.156C329.025 218.329 328.23 216.138 326.403 215.257Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.12
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M345.254 257.07L352.003 235.454L353.551 235.949L347.296 255.996L364.234 261.282L354.325 235.927L355.851 235.325L366.985 263.839L345.254 257.07Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.58
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M349.23 234.788C349.832 232.854 351.896 231.78 353.83 232.382C355.765 232.983 356.839 235.046 356.238 236.98C355.636 238.914 353.572 239.988 351.638 239.386C349.703 238.785 348.629 236.722 349.23 234.788Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.32
  }, _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M358.581 234.466C357.85 232.575 355.722 231.651 353.83 232.382C351.939 233.112 351.014 235.24 351.745 237.13C352.476 239.021 354.604 239.945 356.496 239.215C358.387 238.484 359.311 236.357 358.581 234.466Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M246.551 379.267L343.362 261.346L293.817 379.267H295.601L349.187 251.699L244.444 379.267H246.551Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M295.58 379.267L345.684 260.057L344.179 259.434L293.817 379.267H295.58Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M349.23 379.267H351.745L386.996 349.228L387.448 348.82L348.414 259.391L346.93 260.057L385.47 348.369L349.23 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M344.373 261.368C343.556 259.52 344.416 257.35 346.264 256.533C348.113 255.717 350.284 256.576 351.1 258.424C351.917 260.272 351.057 262.442 349.209 263.259C347.36 264.075 345.189 263.216 344.373 261.368Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.57
  }, _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M348.242 261.325C349.037 259.455 348.156 257.307 346.286 256.512C344.416 255.717 342.266 256.598 341.471 258.467C340.697 260.336 341.557 262.485 343.427 263.28C345.297 264.075 347.446 263.194 348.242 261.325Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.23
  }, _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M49.273 379.267L48.2197 365.795L70.5096 372.756L68.9406 379.267H70.6171L72.2722 372.391L72.4442 371.66L46.4141 363.538L47.6393 379.267H49.273Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M70.6171 379.267L72.1647 372.864L104.686 363.324L94.6911 379.267H96.6041L108.34 360.552L71.2619 371.424L70.8106 371.553L68.9405 379.267H70.6171Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.43
  }, _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M96.6041 379.267L106.728 363.13L127.9 379.267H130.587L107.007 361.282L106.298 360.745L94.6911 379.267H96.6041Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99998 76.9234L64.6201 116.051L-4.54957 140.568L-6.99998 135.432V139.214L-5.38789 142.588L68.5966 116.374L-6.99998 75.0755V76.9234Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M365.072 263.431L354.325 235.927L355.851 235.326L366.147 261.69L401.183 258.102L356.539 234.703L357.291 233.263L406.729 259.155L365.072 263.431Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.28
  }, _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M351.745 237.13C351.014 235.24 351.939 233.112 353.83 232.382C355.722 231.651 357.85 232.575 358.581 234.466C359.311 236.357 358.387 238.484 356.496 239.215C354.604 239.945 352.476 239.021 351.745 237.13Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.07
  }, _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M358.774 230.835C356.968 229.889 354.754 230.577 353.83 232.382C352.884 234.187 353.572 236.4 355.378 237.324C357.183 238.269 359.397 237.582 360.322 235.777C361.267 233.972 360.558 231.759 358.774 230.835Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.3
  }, _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M386.545 352.408L364.599 261.84L400.409 258.188L400.581 259.799L366.619 263.28L386.373 344.78L402.494 261.905L404.085 262.206L386.545 352.408Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M399.936 255.351C401.957 255.137 403.762 256.619 403.956 258.617C404.171 260.637 402.688 262.442 400.689 262.636C398.668 262.85 396.862 261.368 396.669 259.37C396.454 257.35 397.937 255.545 399.936 255.351Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M403.569 366.181L385.578 348.884L385.664 348.454L402.494 261.905L403.612 262.12H404.729L403.569 366.181ZM387.34 348.325L401.978 362.399L403.031 267.577L387.34 348.304V348.325Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.1
  }, _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M399.657 261.54C400.044 259.542 401.978 258.252 403.956 258.639C405.955 259.026 407.244 260.96 406.857 262.937C406.471 264.935 404.536 266.224 402.559 265.837C400.581 265.45 399.27 263.517 399.657 261.54Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M407.588 262.335C407.61 260.315 405.976 258.639 403.956 258.618C401.935 258.596 400.259 260.229 400.237 262.249C400.216 264.269 401.849 265.945 403.87 265.966C405.89 265.988 407.567 264.355 407.588 262.335Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.04
  }, _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M401.957 365.429L403.117 262.098L404.729 262.12L403.59 363.152L507.538 328.407L406.406 261.239L407.309 259.885L511.214 328.88L401.957 365.429Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M400.259 262.249C400.28 260.229 401.935 258.596 403.977 258.618C405.998 258.639 407.631 260.294 407.61 262.335C407.588 264.355 405.933 265.988 403.891 265.966C401.871 265.945 400.237 264.29 400.259 262.249Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.08
  }, _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M409.05 257.608C407.352 256.49 405.073 256.942 403.956 258.639C402.838 260.336 403.289 262.614 404.987 263.731C406.685 264.849 408.942 264.397 410.082 262.7C411.199 261.003 410.748 258.725 409.05 257.608Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.54
  }, _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M138.476 232.64L99.6133 142.244L132.178 132.704L132.651 134.251L101.849 143.297L136.692 224.367L135.015 135.991L136.649 135.97L138.476 232.64Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M132.156 136.227C132.113 134.208 133.725 132.532 135.746 132.489C137.766 132.446 139.443 134.057 139.486 136.077C139.529 138.097 137.917 139.773 135.896 139.816C133.876 139.859 132.199 138.247 132.156 136.227Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.21
  }, _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "M133.274 137.044C135.208 136.464 136.326 134.444 135.767 132.489C135.187 130.555 133.166 129.438 131.21 129.996C129.276 130.576 128.158 132.596 128.717 134.552C129.276 136.507 131.318 137.603 133.274 137.044Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.19
  }, _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M106.986 258.037L100.129 146.284L101.526 146.198L102.837 145.639L138.54 228.686L138.11 229.073L106.964 258.016L106.986 258.037ZM101.827 147.379L108.405 254.513L136.605 228.299L101.827 147.401V147.379Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M97.2919 146.649C97.1629 144.629 98.7105 142.888 100.731 142.76C102.751 142.631 104.493 144.178 104.622 146.197C104.75 148.217 103.203 149.958 101.182 150.087C99.1619 150.216 97.4209 148.668 97.2919 146.649Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.02
  }, _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M105.546 144.693C104.751 142.824 102.58 141.965 100.731 142.781C98.8611 143.576 98.0013 145.746 98.8181 147.594C99.6134 149.464 101.784 150.323 103.633 149.507C105.503 148.712 106.363 146.541 105.546 144.693Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.64
  }, _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M136.799 229.825L135.015 135.991H136.498L137.874 135.39L170.352 212.249L136.821 229.825H136.799ZM136.649 136.7L138.368 227.161L168.246 211.518L136.649 136.7Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.26
  }, _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M139.507 136.099C139.464 134.079 137.788 132.467 135.767 132.51C133.747 132.553 132.135 134.229 132.178 136.249C132.221 138.269 133.897 139.88 135.918 139.837C137.938 139.794 139.55 138.118 139.507 136.099Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.03
  }, _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M105.61 369.383L106.836 259.756L108.469 259.778L107.416 354.492L136.197 230.899L110.812 254.492L109.694 253.31L138.991 226.086L105.61 369.383Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M107.889 251.097C106.406 252.472 106.32 254.793 107.695 256.275C109.071 257.758 111.392 257.844 112.876 256.469C114.359 255.093 114.445 252.773 113.069 251.29C111.693 249.808 109.372 249.722 107.889 251.097Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.69
  }, _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M106.513 358.36L136.885 227.955L170.932 210.121L170.051 212.206L108.619 359.048L107.609 358.618L106.535 358.36H106.513ZM138.304 229.051L109.501 352.687L167.665 213.667L138.282 229.051H138.304Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.42
  }, _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M111.306 359.972C110.533 361.841 108.383 362.722 106.513 361.948C104.643 361.175 103.762 359.026 104.536 357.157C105.309 355.287 107.459 354.406 109.329 355.18C111.199 355.953 112.08 358.102 111.306 359.972Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M103.762 357.522C103.31 359.499 104.536 361.476 106.513 361.927C108.491 362.378 110.468 361.153 110.919 359.176C111.371 357.2 110.146 355.223 108.168 354.772C106.191 354.32 104.213 355.545 103.762 357.522Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.6
  }, _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M2.86613 252.537L-5.83929 140.847L-5.044 140.761L84.2017 132.897L84.3307 134.53L-4.09823 142.308L4.15576 247.981L85.04 135.755L86.3727 136.722L2.86613 252.537Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.41
  }, _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7717 130.082C85.7922 129.91 87.5763 131.393 87.7483 133.413C87.9202 135.432 86.4371 137.216 84.4166 137.388C82.3961 137.56 80.612 136.077 80.4401 134.057C80.2681 132.038 81.7512 130.254 83.7717 130.082Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.15
  }, _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5652 138.527C89.7474 136.894 89.382 134.594 87.7269 133.413C86.0933 132.231 83.7934 132.596 82.6112 134.251C81.429 135.884 81.7944 138.183 83.4495 139.365C85.1046 140.546 87.383 140.181 88.5652 138.527Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.18
  }, _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M-6.99998 142.566L84.3306 134.53L84.2017 132.897L1.33994 140.203L66.4471 117.126L84.5241 131.844L85.5558 130.576L66.7696 115.299L-6.99998 141.427V142.566Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.68
  }, _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M83.7717 130.082C85.7922 129.91 87.5763 131.393 87.7483 133.413C87.9202 135.432 86.4371 137.216 84.4166 137.388C82.3961 137.56 80.612 136.077 80.4401 134.057C80.2681 132.038 81.7512 130.254 83.7717 130.082Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.5
  }, _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M82.5895 133.95C84.1586 135.239 86.4801 134.981 87.7483 133.413C89.038 131.844 88.78 129.524 87.2109 128.256C85.6418 126.967 83.3204 127.225 82.0522 128.793C80.7625 130.362 81.0204 132.682 82.5895 133.95Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M82.6112 134.251C83.7934 132.618 86.0933 132.231 87.7269 133.413C89.3605 134.594 89.7475 136.894 88.5652 138.527C87.383 140.16 85.0831 140.546 83.4495 139.365C81.8159 138.183 81.429 135.884 82.6112 134.251Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M92.8641 132.575C91.2305 131.393 88.9306 131.758 87.7484 133.413C86.5662 135.046 86.9315 137.345 88.5866 138.527C90.2202 139.708 92.5201 139.343 93.7023 137.689C94.8845 136.056 94.5192 133.756 92.8641 132.575Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M395.057 379.267H396.841L403.762 364.097L389.533 350.431L388.415 351.592L401.785 364.484L395.057 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M381.322 379.267L386.588 352.172L384.997 351.871L379.667 379.267H381.322Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.52
  }, _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M386.567 353.783C385.105 352.386 385.062 350.066 386.459 348.605C387.856 347.144 390.199 347.101 391.639 348.497C393.101 349.894 393.144 352.215 391.747 353.676C390.35 355.137 388.007 355.18 386.567 353.783Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.48
  }, _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M389.361 352.902C389.748 350.904 388.458 348.992 386.459 348.605C384.46 348.218 382.547 349.507 382.16 351.506C381.773 353.504 383.063 355.416 385.062 355.803C387.061 356.19 388.974 354.901 389.361 352.902Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M396.863 379.267L402.064 367.793L400.581 367.127L395.057 379.267H396.863Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.22
  }, _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M405.331 379.267L403.977 367.664L402.365 367.836L403.698 379.267H405.331Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M399.549 368.351C399.313 366.332 400.753 364.527 402.773 364.29C404.794 364.054 406.599 365.494 406.836 367.513C407.072 369.533 405.632 371.338 403.612 371.574C401.591 371.811 399.786 370.371 399.549 368.351Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.29
  }, _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M404.6 369.146C405.439 367.298 404.622 365.128 402.773 364.29C400.925 363.452 398.754 364.269 397.916 366.117C397.077 367.965 397.894 370.135 399.743 370.973C401.591 371.811 403.762 370.994 404.6 369.146Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.49
  }, _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M169.406 214.247L168.547 212.206L136.369 136.013L137.874 135.39L169.191 209.52L207.086 88.1612L139.142 131.307L138.261 129.932L209.967 84.4224L169.406 214.247Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.11
  }, _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M133.811 137.302C133.016 135.432 133.897 133.284 135.767 132.489C137.637 131.694 139.787 132.575 140.582 134.444C141.377 136.313 140.496 138.462 138.626 139.257C136.756 140.052 134.607 139.171 133.811 137.302Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M136.885 127.439C135.165 128.535 134.671 130.791 135.746 132.51C136.842 134.229 139.099 134.724 140.819 133.649C142.538 132.553 143.032 130.297 141.958 128.578C140.862 126.859 138.605 126.365 136.885 127.439Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.09
  }, _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M167.493 214.934L206.721 89.3645L208.269 89.8587L171.104 208.832L262.156 114.289L211.278 88.591L212.009 87.1298L264.842 113.817L264.09 114.612L167.493 214.934Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.65
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M203.927 88.6984C204.528 86.7645 206.592 85.6902 208.526 86.2918C210.461 86.8934 211.536 88.9562 210.934 90.89C210.332 92.8238 208.268 93.8982 206.334 93.2966C204.399 92.6949 203.325 90.6322 203.927 88.6984Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.25
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M213.47 84.6801C211.665 83.7562 209.451 84.4867 208.548 86.2916C207.645 88.0965 208.355 90.3097 210.16 91.2122C211.966 92.1361 214.18 91.4055 215.082 89.6006C216.007 87.7957 215.276 85.5825 213.47 84.6801Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.24
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M41.9003 379.267H43.6199L48.3057 364.226L-6.99996 338.313V340.118L46.3282 365.107L41.9003 379.267Z",
    fill: "#5CBF14"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color-dodge"
    },
    opacity: 0.37
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6198 379.267L46.844 368.932L47.6393 379.267H49.2729L47.8113 360.401L41.9002 379.267H43.6198Z",
    fill: "#5CBF14"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeNet1);
export default __webpack_public_path__ + "static/media/home-net1.3f4b531983dd1b10e517d6005f74c048.svg";
export { ForwardRef as ReactComponent };